import { render } from "./CustomerOrderStatus.vue?vue&type=template&id=09babd5f&scoped=true"
import script from "./CustomerOrderStatus.vue?vue&type=script&lang=js"
export * from "./CustomerOrderStatus.vue?vue&type=script&lang=js"

import "./CustomerOrderStatus.vue?vue&type=style&index=0&id=09babd5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09babd5f"]])

export default __exports__